import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { injectIntl, intlShape } from 'react-intl';
import { push } from 'react-router-redux';
import classNames from 'classnames';
import {
  login,
  signup,
  forgot,
  signupReset,
  forgotReset,
} from '../../containers/Auth/actions';
import Login from '../../components/Login';
import Signup from '../../components/Signup';
import Forgot from '../../components/Forgot';
// translate
import messages from './messages';

const modes = ['login', 'signup', 'forgot-password'];

class Popups extends Component {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { isAuthenticated, mode } = nextProps;
    if (isAuthenticated && modes.indexOf(mode) !== -1) {
      const url = localStorage.getItem('settings_full')
        ? '/dashboard'
        : '/profile';
      this.props.dispatch(push(url));
    }
  }

  onClose() {
    this.props.dispatch(signupReset());
    this.props.dispatch(forgotReset());
    this.props.dispatch(push(''));
  }

  render() {
    const {
      intl,
      mode,
      dispatch,
      isFetching,
      loginErrorMessage,
      signupErrorMessage,
      forgotErrorMessage,
      isAuthenticated,
      signupSuccess,
      forgotSuccess,
    } = this.props;

    if (modes.indexOf(mode) === -1 || isAuthenticated) {
      return null;
    }

    return (
      <div>
        <div className="popup-wrap active">
          <div
            className={classNames('popup-reg-wrap registration-wrap', {
              active: mode === 'signup',
            })}
          >
            <div className="popup-reg-inner">
              <div className="popup-reg">
                <p className="popup-header">
                  {intl.formatMessage(messages.registrationTitle)}
                </p>

                <div className="popup-body">
                  <Signup
                    signupErrorMessage={signupErrorMessage}
                    isFetching={isFetching}
                    signupSuccess={signupSuccess}
                    onSignupClick={attributes => dispatch(signup(attributes))}
                  />
                </div>

                <Link className="popup-close trans" onClick={this.onClose} />
              </div>
            </div>
          </div>

          <div
            className={classNames('popup-reg-wrap login-wrap', {
              active: mode === 'login',
            })}
          >
            <div className="popup-reg-inner">
              <div className="popup-reg">
                <p className="popup-header">
                  {intl.formatMessage(messages.loginTitle)}
                </p>

                <div className="popup-body">
                  <Login
                    loginErrorMessage={loginErrorMessage}
                    isFetching={isFetching}
                    onLoginClick={attributes => dispatch(login(attributes))}
                  />
                </div>

                <Link className="popup-close trans" onClick={this.onClose} />
              </div>
            </div>
          </div>

          <div
            className={classNames('popup-reg-wrap forgot-password-wrap', {
              active: mode === 'forgot-password',
            })}
          >
            <div className="popup-reg-inner">
              <div className="popup-reg">
                <p className="popup-header">
                  {intl.formatMessage(messages.forgotTitle)}
                </p>

                <div className="popup-body">
                  <Forgot
                    forgotErrorMessage={forgotErrorMessage}
                    forgotSuccess={forgotSuccess}
                    isFetching={isFetching}
                    onForgotClick={attributes => dispatch(forgot(attributes))}
                  />
                </div>

                <Link className="popup-close trans" onClick={this.onClose} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Popups.propTypes = {
  intl: intlShape.isRequired,
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  loginErrorMessage: PropTypes.any,
  signupErrorMessage: PropTypes.any,
  forgotErrorMessage: PropTypes.any,
  signupSuccess: PropTypes.bool.isRequired,
  forgotSuccess: PropTypes.bool.isRequired,
  mode: PropTypes.string,
};

Popups.defaultProps = {
  mode: '',
  loginErrorMessage: false,
  signupErrorMessage: false,
  forgotErrorMessage: false,
  signupSuccess: false,
  forgotSuccess: false,
};

function mapStateToProps(state) {
  return {
    loginErrorMessage: state.get('auth').loginErrorMessage,
    signupErrorMessage: state.get('auth').signupErrorMessage,
    forgotErrorMessage: state.get('auth').forgotErrorMessage,
    signupSuccess: state.get('auth').signupSuccess,
    forgotSuccess: state.get('auth').forgotSuccess,
    isFetching: state.get('auth').isFetching,
    isAuthenticated: state.get('auth').isAuthenticated,
  };
}

export default connect(mapStateToProps)(injectIntl(Popups));



// WEBPACK FOOTER //
// ./src/containers/Popups/index.js